import { PrivateAxiosInstance } from "config/axios";
const getAuthToken = () => {
  const userDataString = localStorage.getItem("userData");
  const userData = JSON.parse(userDataString);
  return userData?.token;
};

export const API_CREATE_TERMS_CONDITIONS = async (data) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.post(
      "/terms-condition/create-term-condition",
      data,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};

export const API_LIST_TERMS_CONDITIONS = async (params) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.get(
      "/terms-condition/term-conditions",
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
        params: params, // Include dynamic params
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};

export const API_DELETE_TERMS_CONDITIONS = async (id) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.delete(
      `/terms-condition/term-condition/${id}`,
      // data,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};
export const API_UPDATE_TERMS_CONDITIONS = async (id, data) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.put(
      `/terms-condition/update-term-condition/${id}`,
      data,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};
export const API_ENABLE_DISABLE_TERMS_CONDITIONS = async (id) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.put(
      `/terms-condition/enable-disable-term-condition/${id}`,
      null, // No request body for this API call
      {
        headers: {
          Authorization: `${authToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
